import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcn from "../../assets/img/delete_icn.svg";
import { selectNewRequestOtherDestinationsLocation } from "../../redux/newRequest/newRequest.selectors";
import { updateNewRequestOtherDestinationsLocation } from "../../redux/newRequest/newRequest.actions";
import { toPersianNum, toEnglishNum } from "../../assets/utils";
import {
  OtherDestinationsInfoStyled,
  OtherDestinationsInfoCard,
  DestinationsTitle,
  ReciverContainer,
  ReciverInput,
  IconBox,
} from "./otherDestinationInfo.styles";
const OtherDestinationInfo = () => {
  const dispatch = useDispatch();
  const [receiverInfoObj, setReceiverInfoObj] = useState({
    phone: "",
    name: "",
  });
  const otherDestinations = useSelector(
    selectNewRequestOtherDestinationsLocation
  );
  const UpdateOtherDestinationsArray = (obj) => {
    dispatch(updateNewRequestOtherDestinationsLocation(obj));
  };
  return (
    <OtherDestinationsInfoStyled>
      {otherDestinations.map((item, index) => (
        <OtherDestinationsInfoCard>
          <div className="d-flex justify-content-between align-items-center mb-2 mt-1">
            <DestinationsTitle>
              ○ مقصد {toPersianNum(index + 2)}
            </DestinationsTitle>
            <IconBox onClick={()=>UpdateOtherDestinationsArray(item)}>
              <img src={DeleteIcn} alt="d-icn" />
            </IconBox>
          </div>
          <div className="text-white">{item.detail}</div>
          <ReciverContainer>
            <ReciverInput
              type="text"
              value={receiverInfoObj.name}
              onChange={(e) =>
                setReceiverInfoObj({ ...receiverInfoObj, name: e.target.value })
              }
              placeholder="نام تحویل گیرنده"
            />
            <ReciverInput
              type="text"
              value={toPersianNum(receiverInfoObj.phone)}
              onChange={(e) =>
                setReceiverInfoObj({
                  ...receiverInfoObj,
                  phone: toEnglishNum(e.target.value),
                })
              }
              placeholder="تلفن تحویل گیرنده"
            />
          </ReciverContainer>
        </OtherDestinationsInfoCard>
      ))}
    </OtherDestinationsInfoStyled>
  );
};

export default OtherDestinationInfo;
